import useEditorStore from '../stores/editor';

export const useMobileOnly = () => {
  const editorStore = useEditorStore();

  return computed(() => editorStore.mobileOnly);
};
